import type { RegistryEntry, Workspace } from "./types.js";

/**
 * Registry entries with an omitted, null, or app type are the only entries the
 * shell can mount. Legacy and static entries are launcher destinations whose
 * entry value is a URL, not a Module Federation remote.
 */
export function isAppSwitcherEntry(entry: RegistryEntry): boolean {
  const type = entry.type?.trim().toLowerCase();

  return type === undefined || type === "app";
}

export function selectAppEntries(apps: ReadonlyArray<RegistryEntry>): RegistryEntry[] {
  return apps.filter(isAppSwitcherEntry);
}

export function selectShellWorkspaces(workspaces: ReadonlyArray<Workspace>): Workspace[] {
  return workspaces.filter((workspace) => workspace.apps.some(isAppSwitcherEntry));
}

export function selectFirstAppSwitcherEntry(workspace: Workspace): RegistryEntry | undefined {
  return workspace.apps.find(isAppSwitcherEntry);
}
